module.exports = __webpack_public_path__ + "static/media/integral_card_4.30f6030f.png";